import { Component, OnInit } from '@angular/core';
import { AIRPLANEGALLERY } from 'src/app/data/_AIRPLANEGALLERY';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { AirplaneGallery } from 'src/app/models/airplane-gallery';

import { Router, Route, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-airplane-gallery',
  templateUrl: './airplane-gallery.component.html',
  styleUrls: ['./airplane-gallery.component.scss']
})
export class AirplaneGalleryComponent implements OnInit {

  public _AIRPLANEGALLERY = AIRPLANEGALLERY;
  gallery: AirplaneGallery;
  idGallery: number;

  // tslint:disable-next-line:variable-name
  constructor(public _ui: UtilsService, private _route: ActivatedRoute) {

  }

  ngOnInit() {

    // tslint:disable-next-line:triple-equals
    this._AIRPLANEGALLERY = this._AIRPLANEGALLERY.filter(item => item.id == this._route.snapshot.params.id);

    console.log(this._AIRPLANEGALLERY);

  }

  openImage(obj: any) {
    this._ui.openDialog('900px', { url: obj });
  }

}
